export const getUrlIOSorAndroid = () => {
  const userAgent = navigator.userAgent;

  if (/iPad|iPhone|iPod|Macintosh/.test(userAgent)) {
    return 'https://apps.apple.com/br/app/pagol/id1643147483';
  }
  if (/android/i.test(userAgent)) {
    return 'https://play.google.com/store/apps/details?id=com.br.pagol&hl=pt';
  }
  return 'https://bit.ly/QRCodePaGol';
};

export function overrideNodePrototypeMethods() {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        if (console) {
          console.error(
            'Cannot remove a child from a different parent',
            child,
            this
          );
        }
        return child;
      }
      return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          console.error(
            'Cannot insert before a reference node from a different parent',
            referenceNode,
            this
          );
        }
        return newNode;
      }
      return originalInsertBefore.apply(this, arguments);
    };
  }
}
